<template lang="pug">
    section.filter-values
        .tag-row
            el-form-item(:label="relatedFilter.name")
                el-tag(
                    class="filter-tag"
                    v-for="catFilter in relatedFilterValues"
                    v-if="!catFilter.pivot.deleted || catFilter.pivot.deleted === false"
                    :key="catFilter.pivot.id"
                    size="large"
                    :disable-transitions="true"
                    closable
                    @close="handleClose(catFilter)"
                ) {{ catFilter.pivot.value }}
                el-input(
                    class="input-new-filter"
                    v-if="inputVisible"
                    v-model="newFilterValueForm.pivot.value"
                    ref="saveFilterInput"
                    size="small"
                    :disable-transitions="true"
                    @keyup.enter.native="handleInputConfirm"
                    @keydown.enter.native.prevent="handleInputConfirm"
                    @blur="handleInputConfirm"
                    @clear="clearFilterInput"
                    @keydown.escape.native="clearFilterInput"
                    maxlength="255"
                    show-word-limit
                )
                el-button.add-content.centered(
                    v-else
                    type="primary"
                    class="button-new-filter"
                    size="mini"
                    :disable-transitions="true"
                    icon="el-icon-fa-plus fas"
                    @click="addFilterInput"
                ) {{ $t('New filter value') }}
</template>
<i18n>
{
    "de": {
         "New filter value": "Neuer Filterwert"
     }
}
</i18n>
<script>
//import Components
import _ from 'lodash';
import uniqid from 'uniqid';

import { usePageStore } from '@/stores';

export default {
    name: "CategoryFilter",
    data() {
        return {
            inputVisible: false,
            newFilterValueForm: {}
        }
    },
    props: {
        relatedFilter: {
            type: Object,
            required: true
        }
    },
    computed: {
        pageStore() {
            return usePageStore();
        },
        filterValue: {
            set(value) {
                this.pageStore.setFormFilterPivot({ index: 0, value });
            },
            get() {
                return _.get(this.form.pivot, 'value', '')
            }
        },
        relatedFilterValues() {
            let filters = _.get(this.form, 'categoryFilters', []);
            return filters.filter(filter => parseInt(filter.id) === parseInt(this.relatedFilter.id));
        },
        form() {
            return this.pageStore.form;
        },
    },
    methods: {
        currentIndex(filter) {
            let filters = _.get(this.form, 'categoryFilters', []);
            return _.findIndex(filters, filter);
        },
        addFilterInput() {
            this.newFilterValueForm = {
                pivot: {
                    id: uniqid('new:'),
                    value: ''
                }
            };
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveFilterInput.$refs.input.focus();
            });
        },
        clearFilterInput() {
            this.newFilterValueForm = {};
        },
        handleInputConfirm() {
            let filter = _.cloneDeep(this.relatedFilter);
            filter.pivot = _.cloneDeep(this.newFilterValueForm.pivot)
            if (filter && filter.pivot && filter.pivot.value && filter.pivot.value !== '') {
                this.pageStore.addNewFilterInput(filter);
            }
            this.inputVisible = false;
            this.newFilterValueForm = {};
        },
        handleClose(filter) {
            const index = this.currentIndex(filter);
            this.pageStore.removeFilterInput(index);
        }
    }
}
</script>
<style lang="sass" scoped>
    section
        margin-top: 10px

    .button-new-filter
        min-width: 160px
        height: 32px
        line-height: 30px
        padding-top: 0
        padding-bottom: 0
        vertical-align: middle

    .input-new-filter
        width: 160px
        height: 32px
        line-height: 30px
        vertical-align: middle

    .filter-row .el-form-item
        margin-bottom: 0

    .filter-tag:last-of-type
        margin-right: 10px
</style>
